<template>
  <ul :class="['sub-nav', `level-${node.level}`]">
    <menu-item v-for="(submenu,index) in data"
      :key="index"
      :data="submenu">
      <template v-if="submenu.children&&submenu.children.length>0">
        <sub-menu slot="subMenu"
          :data="submenu.children" :node="{data:submenu, level: node.level+1}">
        </sub-menu>
      </template>
    </menu-item>
  </ul>
</template>

<script>
// 组件
import SubMenu from './sub-menu'
import MenuItem from './menu-item'
export default {
  name: 'sub-menu',
  props: {
    data: {
      type: Array,
      default: () => {
        return []
      }
    },
    node: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  components: {
    'sub-menu': SubMenu,
    'menu-item': MenuItem
  },

  methods: {

  }
}
</script>

<style scoped>
.sub-nav {
  position: relative;
  right: 0;
  top: 0;
  z-index: 9;
  display: block;
  text-align: left;
  background: #fff;
}

.level-1 {
  position: absolute;
  top: 50px;
  display: none;
  padding: 10px 0;
  box-shadow: 0 2px 8px rgba(0,0,0,.15);
}
</style>
